// extracted by mini-css-extract-plugin
export default {"Quiz":"Quiz_Quiz__Vv6w6","container":"Quiz_container__-q92Q","imageContainer":"Quiz_imageContainer__cYy+l","image":"Quiz_image__QmdwX"};